/**
 * mwApp.home module <br>
 * Dashboard, system info
 *
 * @namespace mwApp/home
 */

/**
 * ConfigRoutes
 * Configurates module routes
 *
 * @class ConfigRoutes
 * @memberof mwApp/home
 * @see mwApp/home
 *
 * @ngdoc config
 * @name mwApp/home.config:ConfigRoutes
 */
/* @ngInject */
export default function ConfigRoutes ($stateProvider, $urlServiceProvider) {
  $stateProvider

    /**
     * controller {@link mwApp/home.controller:DashboardCtrl}
     * @name /dashboard
     * @memberof mwApp/home.config:ConfigRoutes
     */
    .state('app.dashboard', {
      url: '/',
      templateUrl: 'components/home/views/dashboard.html',
      controller: 'DashboardCtrl as vm',
      label: 'Dashboard',
      access: '', // == 'authenticated', means user should be authenticated
      resolve: {
        settings: /* @ngInject */ function (DashboardSetup) {
          const dashboardSetup = new DashboardSetup()
          return dashboardSetup.settings()
        }
      }
    })

    /**
     * controller {@link mwApp/home.controller:DashboardSetupCtrl}
     * @name /dashboard/setup
     * @memberof mwApp/home.config:ConfigRoutes
     */
    .state('app.setup', {
      url: '/setup',
      templateUrl: 'components/home/views/dashboardSetup.html',
      controller: 'DashboardSetupCtrl as vm',
      label: 'Setup',
      access: '',
      resolve: {
        dashboardSetup: /* @ngInject */ function (DashboardSetup) {
          return new DashboardSetup()
        }
      }
    })

  // handle old /dashboard url
  $urlServiceProvider.rules.when('/dashboard', '/')
}
